export const NODE_PROTOCOL_VERSION = 1;
export const NODE_CAPABILITIES = [
    "terminal",
    "filesystem",
    "screen",
    "input",
    "voice",
    "browser",
    "camera",
    "network",
    "agent",
];
/** Human-readable label per capability (shared by the settings tab and the onboarding gate). */
export const NODE_CAPABILITY_LABELS = {
    terminal: "Terminal",
    filesystem: "Filesystem",
    screen: "Screen",
    input: "Computer input",
    voice: "Voice",
    browser: "Browser",
    camera: "Camera",
    network: "Network",
    agent: "Agent",
};
/** One-line description per capability (shared by the settings tab and the onboarding gate). */
export const NODE_CAPABILITY_DESCRIPTIONS = {
    terminal: "Execute shell commands on this node",
    filesystem: "Read and write files on this node",
    screen: "Share this node’s screen",
    input: "Control the mouse and keyboard on this node",
    voice: "Voice / speech I/O on this node",
    browser: "Drive a browser on this node",
    camera: "Access this node’s camera",
    network: "Use this node’s network / HTTP",
    agent: "Run the agent / CLI sessions on this node",
};
//# sourceMappingURL=node.js.map